import React from 'react';

import Clock from '../Clock';
import logo from '../../assets/logo.png';
import { formatGregorianDate, formatHebrewWeekday } from '../../utils/date';

function getDayTitle(day, isNight) {
  if (day.weekday === 6 && isNight) {
    return 'מוצאי שבת';
  }

  if ((day.weekday === 6 && !isNight) || (day.weekday === 5 && isNight)) {
    return 'שבת שלום!';
  }

  return `יום ${formatHebrewWeekday(day.weekday)}`;
}

function HeaderPanel({ days, isNight, description }) {
  const dateDay = days?.[0] || { dateKey: '', weekday: null, events: [] };
  const activeDay = days?.[isNight ? 1 : 0] || dateDay;
  const hebrewDateText = (activeDay.events || []).find((event) => event.category === 'hebdate')?.hebrew || '';
  const specialDescriptions = String(description || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

  return (
    <div className="row glass header-panel">
      <img
        className="header-logo"
        src={logo}
        alt="ישיבת ההסדר קרית שמונה"
        decoding="async"
        draggable="false"
      />
      <div className="container header-side header-main-side">
        <span className="header-main-title">{getDayTitle(dateDay, isNight)}</span>
        <span className="header-secondary-title">
          {isNight && 'אור ל'}
          {hebrewDateText}
        </span>
        {specialDescriptions.length > 0 && (
          <div className="container header-specials" aria-label="מידע מיוחד">
            {specialDescriptions.map((item, index) => (
              <span className="header-description header-special" key={`${item}-${index}`}>
                {item}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className="container header-side header-time-side">
        <Clock />
        <span className="header-secondary-title">
          {formatGregorianDate(dateDay.dateKey)}
        </span>
      </div>
    </div>
  );
}

export default React.memo(HeaderPanel);
